'use client';

import { useLayoutEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useWindowSize } from 'usehooks-ts';

import { changeSize } from '../model/slice/screenSizeTrackingSlice';

export const ScreenSizeTracking = () => {
  const { width, height } = useWindowSize({ debounceDelay: 200 });
  const dispatch = useDispatch();

  useLayoutEffect(() => {
    dispatch(changeSize({ width, height }));
  }, [width, height, dispatch]);
  return null;
};
